import React from 'react'
import { useTranslation } from 'react-i18next'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import styles from './styles.module.scss'

export const MemberSearchTextBox = ({ searchText, setSearchText }) => {
  const { t } = useTranslation()

  return (
    <SearchTextBox
      value={searchText}
      {...(searchText.length === 0 && { clear: true })}
      minimumSearchChar={appConstantSettings.SEARCH_LENGTH - 1}
      size='large'
      iconPosition='start'
      placeholder={t('moderationReport.tabs.searchPlaceholder')}
      handleSearch={setSearchText}
      cssClass={styles.searchInputContainer}
      inputCssClass={styles.searchInput}
    />
  )
}

export default MemberSearchTextBox
